import address from './address/Reducer';
import attributes from './attributes/Reducer';
import authentication from './authentication/Reducer';
import calendar from './calendar/Reducer';
import cardExpansions from './cardExpansions/Reducer';
import cards from './cards/Reducer';
import carousel from './carousel/Reducer';
import carts from './carts/Reducer';
import catalog from './catalog/Reducer';
import categories from './categories/Reducer';
import categoryLists from './categoryLists/Reducer';
import loading from './common/Loading/Reducer';
import eventReservations from './eventReservations/Reducer';
import interestRegistrations from './interestRegistrations/Reducer';
import inventoryBuffer from './inventoryBuffer/Reducer';
import offers from './offers/Reducer';
import orders from './orders/Reducer';
import paymentTypes from './paymentTypes/Reducer';
import preorders from './preorders/Reducer';
import productLists from './productLists/Reducer';
import products from './products/Reducer';
import roles from './roles/Reducer';
import scheduleProgram from './scheduleProgram/Reducer';
import shipmentManifests from './shipmentManifests/Reducer';
import shopSales from './shopSales/Reducer';
import shops from './shops/Reducer';
import shortUrls from './shortUrl/Reducer';
import sidebar from './sidebar/Reducer';
import stockAccounts from './stockAccount/Reducer';
import stockOperations from './stockOperations/Reducer';
import supplierOrders from './supplierOrders/Reducer';
import suppliers from './suppliers/Reducer';
import units from './units/Reducer';
import users from './users/Reducer';
import vouchers from './vouchers/Reducer';

const reducers = {
    loading,
    authentication,
    users,
    roles,
    address,
    attributes,
    calendar,
    catalog,
    categories,
    products,
    paymentTypes,
    offers,
    orders,
    productLists,
    categoryLists,
    carousel,
    suppliers,
    supplierOrders,
    shopSales,
    shops,
    scheduleProgram,
    stockAccounts,
    units,
    carts,
    vouchers,
    preorders,
    cards,
    cardExpansions,
    stockOperations,
    shortUrls,
    shipmentManifests,
    sidebar,
    inventoryBuffer,
    eventReservations,
    interestRegistrations
}

export default reducers;
